if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.masterId = this.form.querySelector('select[name="id"]');
      this.isPDP = false;
      if(this.masterId){
        this.isPDP = true;
        this.masterId.addEventListener('change', this.onMasterChange.bind(this));
      }
    }

    // When master changes, update variant options
    onMasterChange() {
      const variantData = this.getVariantData().find((variantJsonData) => {
        return variantJsonData.id == this.masterId.value;
      });
      variantData.options.forEach((option,index) => {
        this.querySelector(`[data-fieldset="${index}"] input[value="${option}"]`).checked = true;
      });
      const event = new Event('change');
      this.querySelector('variant-radios').dispatchEvent(event);
      this.form.classList.add('can_atc');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      let sectionsToFetch = [];
      if(this.cartDrawer) {
        sectionsToFetch = [
          ...this.cartDrawer.getSectionsToRender().map((section) => section.id),
          ...this.cartNotification.getSectionsToRender().map((section) => section.id)
        ];
      }

      const formData = new FormData(this.form);

      // If no ID was found in formdata (nothing is selected in MasterIdSelector)
      if(this.isPDP && !formData.get("id")){
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        return;
      }

      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {

          if (parsedState.status == 422 && this.cartNotification) {
            // When quantity error
            this.cartNotification.setActiveElement(document.activeElement);
            this.cartNotification.renderQuantityError(formData.get('inventory_quantity'));
            return;
          }

          if(this.cartDrawer && this.cartNotification){

            this.cartDrawer.renderContents(parsedState);

            switch (submitButton.dataset.addToCartBehavior) {
              case ('open_cart_drawer'):
                this.cartDrawer.open();
                break;
              case ('show_cart_notification'):
              default:
                this.cartNotification.setActiveElement(document.activeElement);
                this.cartNotification.renderContents(parsedState);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}


